module.exports = __webpack_public_path__ + "static/img/waiting_room_front_3.8174bc1.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/waiting_room_front_3.jpg
// module id = 190
// module chunks = 1